module.exports = __webpack_public_path__ + "img/avatar2.99d6ac24.png";